import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Button as MuiButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import { mapAreaTextLinkButtonSx } from "./mapAreaTextLinkButtonSx";

type MapDriversEditDialogProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  message: string;
  confirmLabel: string;
  dismissLabel?: string;
  onConfirm: () => void | Promise<void>;
};

export function MapDriversEditDialog({
  open,
  onClose,
  title,
  message,
  confirmLabel,
  dismissLabel,
  onConfirm,
}: MapDriversEditDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "8px",
          boxShadow: "0px 16px 48px rgba(0, 0, 0, 0.24)",
          maxWidth: 476,
          width: "100%",
        },
      }}
    >
      <DialogTitle
        component="div"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          pr: 1,
          py: 2,
          px: 2,
        }}
      >
        <Typography
          component="span"
          variant="h6"
          sx={{ fontSize: 22, fontWeight: 400 }}
        >
          {title}
        </Typography>
        <IconButton
          aria-label={t("close")}
          onClick={onClose}
          size="small"
          sx={{ color: "grey.600" }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ px: 2, pb: 2, pt: 0 }}>
        <Typography variant="body1" align="center" sx={{ px: 1, fontSize: 16 }}>
          {message}
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: "center",
          gap: 3,
          px: 3,
          py: 2,
          flexWrap: "wrap",
        }}
      >
        <MuiButton
          variant="text"
          color="primary"
          onClick={onClose}
          sx={mapAreaTextLinkButtonSx}
        >
          {dismissLabel ?? t("cancel")}
        </MuiButton>
        <MuiButton
          variant="contained"
          color="primary"
          onClick={async () => {
            await Promise.resolve(onConfirm());
          }}
          sx={{
            textTransform: "none",
            fontWeight: 400,
            fontSize: 16,
            borderRadius: "100px",
            px: 3,
          }}
        >
          {confirmLabel}
        </MuiButton>
      </DialogActions>
    </Dialog>
  );
}
